
<div class="chat-question" >
  <div class="qid-container">
  <div class="qid" >
    Q{{id}}
  </div>
  <!-- <ion-icon name="arrow-forward" class="qid-icon"></ion-icon> -->
  </div>
  <div class="question-container">
   
    <p [ngStyle]="{'background-color':activeQuestionColor }" >{{oldQuestion }}</p>
    <div class="starred">
     
      <ion-icon name="star" class="star-icon"  *ngIf="utilservice.isQuestionStarred(oldQuestion!)"></ion-icon>
    </div>
   
  </div>
  <div class="question-settings">
 
  <app-user-logo ></app-user-logo>
  <ion-img src="assets/images/answer_settings_btn.svg" class="settings-img"  mat-button [matMenuTriggerFor]="answerSettings"></ion-img>
  <mat-menu #answerSettings="matMenu">
    <button mat-menu-item button (click)="updateStarredQuestion(true)" *ngIf="!utilservice.isQuestionStarred(oldQuestion!)">
      <div class="select-schema">
        <ion-icon name="star-outline"  class="star-option"></ion-icon>
        <span >Star</span>
      </div>
    </button>

    <button mat-menu-item button (click)="updateStarredQuestion(false)" *ngIf="utilservice.isQuestionStarred(oldQuestion!)">
      <div class="select-schema">
        <ion-icon name="star"  class="star-option"></ion-icon>
        <span >Unstar</span>
      </div>
    </button>
</mat-menu> 
</div>
<div class="question-indicator">
  <!-- <div class="img-box"  *ngIf="isQuestionActive">
  <ion-img src="assets/images/question_active_one.svg"></ion-img>
  <ion-icon name="play" class="question-active-icon"></ion-icon>
  </div> -->
</div>
</div>